export default "__VITE_ASSET__Ct82MiGp__"